
      <div class="row">
        <div class="loader_containermodel"  *ngIf="loaderShow">
     

          <div class="loader"></div>
        </div>
   @if(step_1){
          <div class="">
            <div class="col-md-12">
               <div class="dr_detaile_container">
                  <div class="dashboard_logo_container">
                     
                     <img src="img/dr_img/logo.png" alt="logo" />
                     <!-- <p class="color_2 headermodelp regular_font">Balanced Life, Balanced Mind</p> -->
                  </div>
               </div>
            </div>
         </div>
      
       
        <div class="col-12 col-md-12 col-lg-7">
          
          <div class="row model modell">
            <div class="col-12 col-md-3">
             <div class="dr_imgmodel_container">
              @if(drDetailsDataFor?.Image){
                
              <img src="{{ drImageBaseUrl + inputFromParent?.Image }}" class="dr_imgmodel" alt="img" />
              } 
              @else{
              <img src="img/default-user.png" class="dr_imgmodel" alt="img" />
              }
              </div>
            </div>
            <div class="col-12 col-md-9  docotername">
              
              <h3 class="semibold font_weight_500 color_4">
                {{ inputFromParent?.FirstName }}
                {{ inputFromParent?.LastName }}
              </h3>
              <p class="regular_font">{{ drDetailsDataFor?.speciality }}</p>
              <p class="regular_font headernamemargin">
                {{ drDetailsDataFor?.experience }}
              </p>
              <div class="row headernamemargin">
                <div class="col-md-6">
                  @if(countryCode=='+91'||countryCode=='91') {
                    <h4 class="front_15 semibold font_weight_500 color_4">First Session<br></h4>

                  <span class="regular_font coure_9" style="font-size: 14px;">
                   <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!=null" style="background: #C8F7E1;padding: 2px 5px;border-radius: 3px;color: #092C44;font-size: 14px;margin-right: 10px;" >{{this.accessCodedata}}%</span>
                    <span  *ngIf="drDetailsDataFor?.isFirstAppointment==1 &&this.accessCodedata==null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   <span  *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   <span  *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata==null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                    <span style="text-decoration: line-through;margin-left:5px;margin-right: 5px;" *ngIf="drDetailsDataFor?.isFirstAppointment==1 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   
                    <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!=null" >
                      {{
                              roundUp(drDetailsDataFor?.first_appointment_fee- (drDetailsDataFor?.first_appointment_fee / 100) *
                              drDetailsDataFor?.accessCode.discount)
                      }}
                  </span>
                    <!-- {{ -->
                    <!-- drDetailsDataFor?.currencySymbol}}  -->
                    <!--  -->
                    <!-- {{ roundUp(drDetailsDataFor?.first_appointment_fee) }} -->

                    /     @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                } 
                  </span>
                  }
                  @else {
                  <span class="regular_font coure_9">
                    <h4 class="front_15 semibold font_weight_500 color_4">First Session<br></h4>
                     <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!=null" style="background: #C8F7E1;padding: 2px 5px;border-radius: 3px;color: #092C44;font-size: 14px;margin-right: 10px;" >{{this.accessCodedata}}%</span>
                    <span  *ngIf="drDetailsDataFor?.isFirstAppointment==1 &&this.accessCodedata==null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   <span  *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                    <span  *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata==null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   <span style="text-decoration: line-through;margin-left:5px;margin-right: 5px;" *ngIf="drDetailsDataFor?.isFirstAppointment==1 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.first_appointment_fee )}}</span>
                   
                    <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!=null" >
                      {{ drDetailsDataFor?.currencySymbol }}
                      {{
                              roundUp(drDetailsDataFor?.first_appointment_fee- (drDetailsDataFor?.first_appointment_fee / 100) *
                              drDetailsDataFor?.accessCode.discount)
                      }}
                  </span>
                      <!-- {{drDetailsDataFor?.currencySymbol}} -->
                    <!-- {{ -->
                    <!-- roundUp(drDetailsDataFor?.first_appointment_fee) -->
                    <!-- }} -->
                    / @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                } 
                  </span>
                  }
                </div>
                <div class="col-md-6 regular_font coure_9">
                  <h4  class="front_15 semibold font_weight_500 color_4">  Follow up Session<br ></h4>

                  
                  @if(countryCode=='+91'||countryCode=='91') {
                  <span *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata!=null" style="background: #C8F7E1;padding: 2px 5px;border-radius: 3px;color: #092C44;font-size: 14px;margin-right: 10px;" >{{this.accessCodedata}}%</span>
                  <span style="font-size: 14px;">
                     <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata== null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                            <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!= null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                             <span *ngIf="drDetailsDataFor?.isFirstAppointment==0 && this.accessCodedata== null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                     <span style="text-decoration: line-through;" *ngIf="drDetailsDataFor?.isFirstAppointment==0&&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                  <span style="margin-left:10px" *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }}
                     
                     {{
                              roundUp(drDetailsDataFor?.follow_up_fee- (drDetailsDataFor?.follow_up_fee / 100) *
                              drDetailsDataFor?.accessCode.discount)}}</span> /
                  @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                } 
                  </span>
                   

                  }
                  @else {
                         <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata== null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                            <span *ngIf="drDetailsDataFor?.isFirstAppointment==1 && this.accessCodedata!= null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                            <span *ngIf="drDetailsDataFor?.isFirstAppointment==0 && this.accessCodedata== null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                     <span style="text-decoration: line-through;" *ngIf="drDetailsDataFor?.isFirstAppointment==0 && this.accessCodedata!= null">{{ drDetailsDataFor?.currencySymbol }} {{roundUp( drDetailsDataFor?.follow_up_fee )}}</span>
                  <span style="margin-left:10px" *ngIf="drDetailsDataFor?.isFirstAppointment==0 &&this.accessCodedata!=null">{{ drDetailsDataFor?.currencySymbol }}
                     
                     {{
                              roundUp(drDetailsDataFor?.follow_up_fee- (drDetailsDataFor?.follow_up_fee / 100) *
                              drDetailsDataFor?.accessCode.discount)}} </span>
                  <!-- <span>{{ drDetailsDataFor?.currencySymbol }}{{ roundUp(drDetailsDataFor?.follow_up_fee) }} -->
                    
                    
                    /
                   @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                } 
                 
                   <!-- <span *ngIf="accessCodedata" style="background: #C8F7E1;padding: 2px 5px;border-radius: 3px;color: #092C44;">{{this.accessCodedata}}%</span> -->
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2 modell">
            <div class="col-lg-12">
              <ul class="assesment_list_tab" style="border-bottom: 1px solid #c7e6f2">
                @for(t of assentListTab; track $index){
                <li (click)="OnClick_Header(t.id,3,$event)" [ngClass]="{ my_class: slideShow == t.id }">
                  {{ t.name }}
                </li>
                }
              </ul>
            </div>
          </div>
          @if(slideShow==1){
          <div class="row modell dr_tab_details">
            <div class="col-md-12">
              <p class="regular_font">{{ drDetailsDataFor?.description }}</p>
            </div>
            <div class="col-md-6 mt-4">
              <h6 class="semibold color_4 font_weight_500">Language</h6>
              <p class="regular_font" style="word-wrap: break-word;margin-top: 15px;">
                {{ drDetailsDataFor?.language }}
              </p>
            </div>
            <div class="col-md-6 mt-4">
              <h6 class="semibold color_4 font_weight_6500">Registration</h6>
              {{ drDetailsDataFor?.npi_no }}
            </div>
            <div class="col-md-11 mt-4">
              <h6 class="semibold color_4 font_weight_500">
                Professional Membership
              </h6>
              <p class="regular_font">
                {{ drDetailsDataFor?.professional_Membership }}
              </p>
            </div>
          </div>
          } @if(slideShow==2){
          <div class="row modell">
            <div class="col-md-12 dr_tab_details">
              @for(s of specialisation;track $index){
              <div class="spelication">
                {{ s }}
              </div>
              }
              @empty {
              <p class="text-center">Data not available</p>
              }
              <!-- <p>{{drDetailsDataFor?.specialisation}}</p> -->
            </div>
          </div>
          } @if(slideShow==3){
          <div class="row modell">
            <div class="col-md-12 dr_tab_details">
              @if(drDetailsDataFor?.education ){
              <p>{{ drDetailsDataFor?.education }}</p>
              }
              @else(){
              <p class="text-center">Data not available</p>
              }
            </div>
          </div>
          }
          @if(slideShow==4){
          <div class="row modell">
            <div class="col-md-12 dr_tab_details">
              @for(l of hcpReviewByPatient; track $index){
              <div class="row ratingreview">
                <div class="col-3">
                  <img src="{{ drImageBaseUrl + l.image }}" onerror="this.src='img/default-user.png' ; " style="width: 100%;margin-bottom: 26px;border-radius: 10px;margin-top: 10px;height: 120px;"/>
                </div>
                <div class="col-9 mt-2">
                  <h5 class="semibold">{{ l.patient_name }}</h5>
                  <p class="regular_font">{{ l.date | date : "dd-MM-yyyy" }}</p>
                  <div class="starcolur">
                    <td *ngIf="l.rating == '5.0'">
                      &#9733; &#9733; &#9733; &#9733; &#9733;
                    </td>
                    <td *ngIf="l.rating == '4.5'">
                      &#9733; &#9733; &#9733; &#9733;
                      <fa-icon [icon]="faStarHalfStroke"></fa-icon>
                    </td>
                    <td *ngIf="l.rating == '4.0'">
                      &#9733; &#9733; &#9733; &#9733;
                    </td>
                    <td *ngIf="l.rating == '3.5'">
                      &#9733; &#9733; &#9733;
                      <fa-icon [icon]="faStarHalfStroke"></fa-icon>
                    </td>
                    <td *ngIf="l.rating == '3.0'">&#9733; &#9733; &#9733;</td>
                    <td *ngIf="l.rating == '2.5'">
                      &#9733; &#9733;
                      <fa-icon [icon]="faStarHalfStroke"></fa-icon>
                    </td>
                    <td *ngIf="l.rating == '2.0'">&#9733; &#9733;</td>
                    <td *ngIf="l.rating == '1.5'">
                      &#9733;
                      <fa-icon [icon]="faStarHalfStroke"></fa-icon>
                    </td>
                    <td *ngIf="l.rating == '1'">&#9733;</td>
                  </div>
                  <p class="regular_font">
                    {{ l.Likes_Data.length }} people found this useful
                  </p>
                  <p class="mt-1 regular_font">{{ l.review_content }}</p>
                </div>
              </div>
              }
              @empty {
              <p class="text-center">Data not available</p>
              }
            </div>
          </div>
          }
        </div>
        <div class="col-12 col-md-12 col-lg-5">
          <div class="modelcard">

            <div class="row mt-3">
              @if(countryCode=='+91'||countryCode=='91'){

              
              <h6 class="semibold font_weight_500 color_4">Book Session with {{ inputFromParent?.FirstName }}</h6>
              @if(!accessCodedata){
              <div class="tabbtn mt-2">
                <ul class="sessionType">
                  @for(t of sessionArrayBook; track $index){
                  <li (click)="sessionBookTabEvent(t,3,$event)" class="color_4 sessionTypelistcommon tabsessionTypelistseperate"
                    [ngClass]="{ my_class_type: sessionBookTab == t.id }">
                    <!-- <img src="{{t.icon}}" class="tabimage" alt="img"/>  -->
                    <i class="{{ t.class }}" aria-hidden="true"></i>
                    {{ t.name }}
                  </li>
                  }
                </ul>
              </div>
            }
            }
               
                <div class="tabbtn ">
                  @if(selectPakageSession==true){
                  <h6 class="semibold font_weight_500 color_4">Select Package Type</h6>
                  <ul class="sessionType mt-2">
                    @for(t of selectPakageType; track $index){
                    <li (click)="selectPakageTypeTab(t.id,3,$event)" class=" color_4 tabwith sessionTypelistcommon tabsessionTypelist semibold"
                      [ngClass]="{ my_class_type: selectPakageTypeTabShow == t.id }">
                      <!-- <img src="{{t.icon}}" class="tabimage" alt="img"/>  -->
                      <i class="{{ t.class }}" aria-hidden="true"></i>
                      {{ t.name }}
                    </li>
                    }
                   
                  </ul>
                }
                </div>
              
             
             
              <div class="tabbtn mt-2">
                @if(changeStepOfpackage==true){
                  @if(selectedPackageTypeSssion==1){
                    <h6 class="book_session_pakagename"><img class="commaoncursor" src="backarrow.png" alt="back icon session package"  (click)="backStepForpakace()"> Individual Package / {{no_of_calls}} Sessions</h6>
                  }
                  @if(selectedPackageTypeSssion==2){
                    <h6 class="book_session_pakagename" ><img class="commaoncursor" src="backarrow.png" alt="back icon session package"  (click)="backStepForpakace()"> Couple Package / {{no_of_calls}} Sessions</h6>
                  }
              
                }
                @if(selectSingleSession==true){
                  <h6 class="semibold font_weight_500 color_4">Select Session Type</h6>
                  <ul class="sessionType mt-2">
                    @for(t of sessionTypeArray; track $index){
                    <li (click)="sessionTypeTab(t,3,$event)" class=" color_4 sessionTypelistcommon tabsessionTypelist"
                      [ngClass]="{ my_class_type: sessionTypeShow1 == t.id }">
                      <!-- <img src="{{t.icon}}" class="tabimage" alt="img"/>  -->
                      <i class="{{ t.class }}" aria-hidden="true"></i>
                      {{ t.name }}
                    </li>
                    }
                  </ul>
                }
               
              </div>
            </div>
            

            
            <div class="row">
              @if(selectPakageSession==true ){
              <div class="col-12 pakage-list-container-box">
                @for (item of packageTypeData; track $index) {
                  <div class="package-container">
                    <div class="row">
                      <div class="col-6">
                        @if(item?.package_type==2){
                          <p class="package-title pakage-common-color">Couple Package</p>
                        }
                        @else {
                          <p class="package-title pakage-common-color">
                            Individual Package
                          </p>
                        }
                        
                      </div>
                      <div class="col-6 text-end">
                        <p class="session-time pakage-common-color">{{item?.minutes}} min / Session</p>
                      </div>
                      <div class="col-6">
                        <p class="session-count color_4 font_weight_500 semibold">{{item?.no_of_calls}} Sessions</p>
                      </div>
                      <div class="col-6 text-end">
                        <p class="pricing">
                          <span class="discount-price color_4 font_weight_500 semibold">{{drDetailsDataFor?.currencySymbol}}{{item?.discounted_amount}}</span>
                          <del class="original-price pakage-common-color font_weight_500 semibold">{{drDetailsDataFor?.currencySymbol}}{{item?.original_amount}}</del>
                        </p>
                      </div>
                      <div class="col-12">
                        <button (click)="selectPackageData(item,3,$event)" class="btn custom-btn-color position-relative">
                          <span class="discount-off-text color_4 semibold">{{item?.percentage_off}}% OFF</span>
                          <span class="ms-2  color_4 semibold">{{item?.package_code}}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                }
                @empty {
                  <p class="text-center">Package Type not available</p>
                  }  
                       
            </div>
          }
          
        </div>
            <div class="row ">
              @if(selectSingleSession==true){
                <div class="col-12">
                  <div>
                    <div class="d-flex justify-content-between w-100">
                      <h6 class="semibold font_weight_500 color_4">Schedules</h6>
                      <p class="regular_font color_4 front_11">
                        {{ currentDateForSchedule | date }}
                      </p>
                      <!-- <p>{{this.currentDateForSchedule}}</p> -->
                    </div>
                    <div class="schdeule_container inputcalendericon">
                      @for(c of getHcpScheduleData; track $index){
                      <div class="schdeule_sub_container" (click)="gGetAvailableBlockOfAppointmentCheck(c,3,$event)" [ngClass]="{
                          shedulermy_class_type: schedulTabTypeShow == c.Date
                        }">
                        <div class="color_6">
                          {{c.Date*1000| date : "EE" }}
  
  
                        </div>
                        <div class="color_4 font_weight_600">
                          {{ c.Date*1000 | date : "d" }}
                        </div>
                      </div>
                      <!-- <span class="schedule" (click)="gGetAvailableBlockOfAppointmentCheck(c)">{{c.Date|date:'EE d'}}</span> -->
                      }
                      <input type="date" class="clanderimage  form-control" [min]="MinFromDate" (keydown)="disableDate()" #gg
                        (change)="getDateCalender(gg)" />
                    </div>
                    <!-- <img src="img/date.png" class="dateimg"> -->
                  </div>
                  <div style="clear: both"></div>
                  <div class="mt-3">
                    <div class="d-flex justify-content-between w-100">
                      <h6 class="semiboldfont_weight_500 color_4">Available Slots</h6>
                      <p class="regular_font color_4 front_11">IST</p>
                    </div>
                    <div class="row avaibilitySlot">
  
                      @for(s of drAvaibilityDataFor; track $index){
                      <div class=" col-6 col-md-4 mb-3">
                        <button title="{{s.BlockStatus}}" class="calendar-day" (click)="availableTab(s,3,$event)" [disabled]="
                            s.BlockStatus == 'Pending' ||
                            s.BlockStatus == 'Busy' ||
                            s.BlockStatus != 'Available'
                          " [ngClass]="{
                            shedulermy_class_type:
                              availabeTabTypeShow == s.BlockTitle,
                            my_class2_busy: s.BlockStatus == 'Busy',
                            my_class3_pending: s.BlockStatus == 'Pending'
                          }">
                          {{ s.BlockTitle }}
                        </button>
                      </div>
                      } @empty {
                      <p class="text-center">Wellness Advisors is not available</p>
                      }
                    </div>
                  </div>
                  <div class="mt-2">
                    <button class="book_session_btn semibold" [disabled]="booktbnEnable" (click)="bookSessionWithDr(3,$event)">
                      Book Session
                    </button>
                  </div>
                  <div class="mt-3">
                    @if(selectedPackageTypeSssion==1){
                      <h6 class="book_session_pakagename book_session_pakagename1">This booking reserves the first of your {{no_of_calls}} Individual's sessions.</h6>
                    }
                    @if(selectedPackageTypeSssion==2){
                      <h6 class="book_session_pakagename book_session_pakagename1"> This booking reserves the first of your {{no_of_calls}}  couple's sessions.</h6>
                    }
                  </div>
                </div>
              }
             
            </div>
          
        </div>
      </div>
    }
    @if(step_2){
      <div >
        <div class="col-12">
          <div class="row modelcalss">
            <div class="col-12 col-sm-4 col-md-4 col-lg-3">
              @if(drDetailsDataFor?.Image!=''){
              <img src="{{ drImageBaseUrl + drDetailsDataFor?.Image }}" class="dr_img_book" alt="img" />
              } @else{
              <img src="img/default-user.png" class="dr_img_book" alt="img" />
              }
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-5">
              <div class="d-flex justify-content-between w-100 top">
                <h3 class="semibold color_4">
                  {{ drDetailsDataFor?.FirstName }}
                  {{ drDetailsDataFor?.LastName }}
                </h3>
                
              </div>
              <p class="regular_font color_8">
                {{ drDetailsDataFor?.speciality }}
              </p>
              <div class="totalview_container totalview_container1">
                <div class="dr_rating_box dr_rating_box1 starcolure">
                  &#9733;
                  <span class="spainrating">{{
                    drDetailsDataFor?.rating
                    }}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-3 col-md-3 col-lg-4">
                @if (selectedPackageTypeSssion==1) {
                  <p class="pakagename color_4 semibold">Individual Package</p>
                }
                @if(selectedPackageTypeSssion==2) {
                  <p class="pakagename color_4 semibold">Couple Package</p>
                }
                
            </div>
          </div>
          <div class="borderbuttom"></div>
          <div class="row">
            <div class="col-7 col-md-4 font_weight_500 semibold front_15 color_4">
              Appointment Date :
            </div>
            <div class="col-5 col-md-2">
              {{ schedulTabTypeShow*1000 |date:'MMM d, y' }}
            </div>
            <div class="col-7 col-md-4 font_weight_500 font_weight_500 semibold front_15 color_4">
              Appointment Time :
            </div>
            <div class="col-5 col-md-2">
              {{ availabeTabTypeShow }}
            </div>
          </div>
          <div class="borderbuttom"></div>
          <div class="row mt-3">
            <div class="col-5 col-md-4 font_weight_500 semibold front_15">
              Paid Fee:
            </div>
          
            @if(countryCode=='+91'|| countryCode=='91'){
            <div class="col-7 col-md-4">
            
              @if(IsflowupAppointmentcheckedValue){
  
               @if(selectedPackageTypeSssion){
                 <span style="text-decoration: line-through;margin-right: 20px;">{{drDetailsDataFor?.currencySymbol}}{{roundUp(this.originalPakageAmount)}}</span> 
                 <span>{{drDetailsDataFor?.currencySymbol}}{{roundUp(this.feeAmount)}}</span> 
                <!-- {{ this.feeAmount| currency : "INR":'symbol':'1.0-0' }}  -->
               
               }
               @else {
                <span  *ngIf="accessCodedata==null">{{drDetailsDataFor?.currencySymbol}}{{ roundUp(drDetailsDataFor?.follow_up_fee)}} </span>
                 <span style="text-decoration: line-through;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{roundUp( drDetailsDataFor?.follow_up_fee  )}} </span> <span style="margin-left: 10px;" *ngIf="accessCodedata">
  {{
    roundUp(
      drDetailsDataFor?.follow_up_fee -
      (drDetailsDataFor?.follow_up_fee / 100) * accessCodedata
    )
  }}
</span> /
                 @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                  @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                }
                                 
                                } 
               }
             
            } 
              @else {
                @if(selectedPackageTypeSssion){
                  <span style="text-decoration: line-through;margin-right: 20px;">{{this.originalPakageAmount }}</span> 
                 <span>{{drDetailsDataFor?.currencySymbol}}{{roundUp(this.feeAmount)}}</span> 
                 
                 }
                 @else {
                
                 <span  *ngIf="accessCodedata==null">{{drDetailsDataFor?.currencySymbol}}{{ roundUp(drDetailsDataFor?.first_appointment_fee)}} </span>
                 <span style="text-decoration: line-through;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{roundUp( drDetailsDataFor?.first_appointment_fee)}} </span> 
                 <span style="margin-left: 10px;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{roundUp(drDetailsDataFor?.first_appointment_fee- (drDetailsDataFor?.first_appointment_fee / 100) * accessCodedata ) }}</span>
                 
                    / @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                }
                 }
            
            
            }
            </div>
            }
            @else {
            <div class="col-7 col-md-4">
          <!--fllow up true usa --->
          <!-- {{drDetailsDataFor?.isFirstAppointment}} -->
              @if(IsflowupAppointmentcheckedValue){
             
       

               <span *ngIf="accessCodedata==null">{{drDetailsDataFor?.currencySymbol}}{{  roundUp(drDetailsDataFor?.follow_up_fee)}} </span>
                 <span style="text-decoration: line-through;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{roundUp( drDetailsDataFor?.follow_up_fee)}} </span> <span style="margin-left: 10px;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{ roundUp(drDetailsDataFor?.follow_up_fee- (drDetailsDataFor?.follow_up_fee / 100) * accessCodedata ) }}</span>
                  / @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                }
            } 
            @else {
            
              
                 <span *ngIf="accessCodedata==null">{{drDetailsDataFor?.currencySymbol}}{{  roundUp(drDetailsDataFor?.first_appointment_fee)}} </span>
                 <span style="text-decoration: line-through;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{roundUp( drDetailsDataFor?.first_appointment_fee)}} </span> <span style="margin-left: 10px;" *ngIf="accessCodedata">{{drDetailsDataFor?.currencySymbol}}{{ roundUp(drDetailsDataFor?.first_appointment_fee- (drDetailsDataFor?.first_appointment_fee / 100) * accessCodedata )}}</span>
                 @if(drDetailsDataFor?.showSlot==0){
                                  Session
                                }
                                @else{
                                   {{ drDetailsDataFor?.appointment_minute }} min
                                }


             }
            </div>
            }
          </div>
          <div class="borderbuttom"></div>
          <div class="row">
            <div class="col-12">
              <label class="font_weight_500 font_weight_500 semibold front_15 color_4">Your Difficulties</label>
              <input type="" class="form-control inputfromclass" [(ngModel)]="describeDifficulties" />
            </div>
            <div class="col-12 mt-2">
              <label class="font_weight_500 font_weight_500 semibold front_15 color_4">Duration of the
                Difficulties</label>
              <!-- <select class="form-control inputfromclass" [(ngModel)]="duration_of_difficulties"  (ngModelChange)="trackDifficultyDuration($event)" style="background-image: url(./media/arrow.png) !important;outline: none;background-repeat: no-repeat !important;background-position: right 15px center !important;margin-right: 8px;">
                 <option value="">Select Duration </option>
                <option value="1-3 Days">1-3 Days</option>
                <option value="3-6 Days">3-6 Days</option>
                <option value="1-2 week">1-2 week</option>
                <option value="3-4 week">3-4 week</option>
                <option value="4-5 week">4-5 week</option>
                <option value="3-4 Months">3-4 Months</option>
                <option value="1-2 Months">4-5 Months</option>
              
              </select> -->
                <select class="form-control "
            [(ngModel)]="duration_of_difficulties"
            name="duration_of_difficulties"
            required
            (ngModelChange)="onDurationChange($event)" style="background-image: url(img/arrow_dropdown.png) !important;outline: none;background-repeat: no-repeat !important;background-position: right 15px center !important;margin-right: 8px;">

      <option value="">Select Duration</option>
      <option *ngFor="let option of predefinedOptions"
              [value]="option">
        {{ option }}
      </option>
      <option value="Others">Others</option>

    </select>
            </div>
             <div class="form-group mt-2"
       *ngIf="duration_of_difficulties === 'Others'">

    <label>Please Specify</label>

    <input type="text"
           class="form-control"
           [(ngModel)]="otherDuration"
           name="otherDuration"
             maxlength="20"
           [required]="duration_of_difficulties === 'Others'">

    

  </div>
            <div class="col-12 mt-2">
              <label class="font_weight_500 font_weight_500 semibold front_15 color_4">Rating of your difficulties are
                affecting your daily
                functioning</label>
              <div class="rating-container">
                <div class="rating-scale">
                  @for(r of dificultyRate; track $index){
                  <div class="rating-item">
                    <p>{{ r.id }}</p>
                    <img src={{r.src}} class="emojiimagge" #icon1 alt="man" (click)="gitRattingValue(r,icon1)" />
                  </div>
                  }
                  
                </div>
                <div class="row mt-2">
                  <div class="col-6 col-md-6">
                    <p style="color:#83D4B7">least affected</p>
                  </div>
                  <div class="col-6 col-md-6">
                    <p class="efacting">extremely affected</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="font_weight_500 semibold front_15 color_4">Consulting</label>
            </div>
            <div style="display: flex;">
              <div class="col-12 col-md-6 rediobtn">
                @if(IsfirstAppointmentcheckedValue){
                <div class="radion_circle_1">
                  <div class="radion_circle_2"></div>
                </div>
                }@else {
                <div class="radion_circle_1">
                </div>
                }
               
                <label for="Consulting first time">Consulting first time</label>
              </div>
              <div class="col-12 col-md-6 rediobtn">
                @if(IsflowupAppointmentcheckedValue){
                <div class="radion_circle_1">
                  <div class="radion_circle_2"></div>
                </div>
                }
                @else {
                <div class="radion_circle_1">
                </div>
                }
               
                  <label for="Follow up session">Follow up session</label>
              </div>
              </div>
              <div class="row">
              @if(selectedPackageTypeSssion){
                
                <div class="row mt-4">
                  <label class="font_weight_500 semibold front_15">
                    Have a coupon? Apply here 
                  </label>
                  <div class=" col-8 col-md-10 mt-2">
                    <input type="" class="form-control inputfromclass" [(ngModel)]="package_code"
                      [disabled]="couponCodeDesiabled" />
                  </div>
                  <div class="col-4 col-md-2">
                    <button class="applaybtn font_weight_500 semibold border_radius_10"
                       [disabled]="true">
                      {{ applyText }}
                    </button>
                  </div>
                  </div>
              }
              
  
              @if(countryCode=='91'||countryCode=='+91'){
               

                
              @if(cuponData){
                @if(!selectedPackageTypeSssion){
                  @if(!accessCodedata){
              <div class="row mt-4">
                <label class="font_weight_500 semibold front_15">
                  Have a coupon? Apply here
                </label>
                <div class="col-8 col-md-10 mt-2">
                  <input type="" class="form-control inputfromclass" [(ngModel)]="couponCodeText"
                    [disabled]="couponCodeDesiabled" />
                </div>
                <div class="col-4 col-md-2">
                  <button class="applaybtn font_weight_500 semibold border_radius_10"
                    (click)="applyCouponCode(couponCodeText,'0',4,$event)" [disabled]="couponCodeDesiabled">
                    {{ applyText }}
                  </button>
                </div>
                <div class="col-md-12 color_5">
                  {{couponCodeMessage}}
                </div>
              </div>
          
              @for (item of cuponData; track $index) {
              <div class="row">
                <div class="container">
                  <div class="col-md-12 applycard">
                    <div class="row">
                      <div class="col-md-9">
                        <span class="regular_font color_4">Use Code:</span>
                        <span style="padding-left: 10px;"> <b class="semibold color_4">{{ item?.coupon_name
                            }}</b></span>
                        <p class="regular_font front_11 color_4">
                          {{ item?.Short_Description }}
                        </p>
                      </div>
                      <div class="col-md-3">
                         @if (appliedCoupon === item?.coupon_name) {
                          <button (click)="removedCouponCode(2,$event)" class="removed_coupon semibold">
                            Remove
                          </button>
                        } @else {
                          <button (click)="applyCouponCode(item, '1',4,$event)" class="apply_coupon semibold">
                            Apply
                          </button>
                        }

                       <!-- @if(removeApplyBtn){ -->
                        <!-- <button (click)="applyCouponCode(item,'1')" class="apply_coupon semibold"> -->
                          <!-- Apply -->
                        <!-- </button> -->
                        <!-- } @else { -->
                        <!-- <button (click)="removedCouponCode()" class="removed_coupon semibold"> -->
                          <!-- Removed -->
                        <!-- </button> -->
                        <!-- } -->
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
             
  
              @if(couponList){
              <section class="amount_payble_cuppon">
  
                <div class="container">
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <h2 class="color_4 semibold front_15">Amount Payable</h2>
                      <div class="blackborder"></div>
                    </div>
                  </div>
                  <div class="row toprow">
                    <div class="col-md-10">
                      <p class="regular_font mbzero">Price</p>
                    </div>
                    <div class="col-md-2">
                      @if(IsflowupAppointmentcheckedValue){
                        <p class="mbzero">
                       {{drDetailsDataFor?.currencySymbol}} {{ roundUp(drDetailsDataFor?.follow_up_fee)}}
                      </p>
                      }
                      @else {
                        <p class="mbzero">
                        {{drDetailsDataFor?.currencySymbol}}{{ roundUp(drDetailsDataFor?.first_appointment_fee)}}
                      </p>
                      }
                     
                    </div>
                  </div>
                  <div class="row toprow">
                    <div class="col-md-10">
                      <p class="reqular_font mbzero">Coupon Discount</p>
                    </div>
                    <div class="col-md-2">
                      @if(IsflowupAppointmentcheckedValue){
                        <p class="mbzero" style="color: #83D4B7;">
                        - {{
                        drDetailsDataFor?.currencySymbol}} {{roundUp( drDetailsDataFor?.follow_up_fee -
                        couponList?.amount_to_be_paid)
                        }}
                      </p>
                      }
                      @else {
                        <p class="mbzero" style="color: #83D4B7;">
                        -{{drDetailsDataFor?.currencySymbol}} {{
                        roundUp(drDetailsDataFor?.first_appointment_fee - couponList?.amount_to_be_paid)
                        }}
                      </p>
                      }
                     
                    </div>
                  
                  </div>
                  <div class="dashbuttom margintop"></div>
                  <div class="row">
                    <div class="col-md-10">
                      <b class="regular_font color_4">Final Amount</b>
                    </div>
                    <div class="col-md-2">
                      <p>
                        {{drDetailsDataFor?.currencySymbol}}
                        {{ roundUp(couponList?.amount_to_be_paid) }}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              }
            }
              }
              }
             
              <button class="resudelbtn font_weight_500 semibold" (click)="placeAppointmentReques(2,$event)">
                Place Appointment Request <img src="img/dr_img/Vecto.png" alt="img" style="height: 21px;width: 21px;">
              </button>
              <div class="text-center color_8 mt-2">
                Your booking confirms acceptance of our   <span style="color: #309EFF;"><a  target="_blank" style="text-decoration: none;" href="consent-form"> Consent Form.</a></span> 
              </div>
            </div>
          </div>
        </div>
      </div>
    }



<div class="modal" id="test1234" style="background-color: #000000c2" tabindex="-1" role="dialog"
[ngStyle]="{ display: displayStyle4 }">
<div class="modal-dialog modal-sm" role="document">
  <div class="modal-content main_model_bg modelpading">
    <div class="row">
      <div class="col-12">
        <h3 class="semibold font_weight_500 front_20 fontsize20 color_10">
          Your Session Is Booked
        </h3>
        <p class="regular_font color_8">
          Relax and take a moment for yourself. We'll ensure you're reminded
          when it's time for your session.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="semibold font_weight_500 book_session_btn" (click)="backtohomeOpenModel(2,$event)">
          Back to home
        </button>
      </div>
    </div>
  </div>
</div>
</div>
<!---<button (click)="testModel()">Okkkk</button>---->
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header color_4 color_2 semibold">
      <h5 class="modal-title pahddingHeaderpopbox">Let us know a good time to talk</h5>
      <button type="button" class="close closepopbocheader1" (click)="closePopup()" data-dismiss="modal"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="RqestQueryFormData" (submit)="saverequestquerydata(RqestQueryFormData)">
      <div class="row paddMid">
        <div class="col-md-6">
          <label class="semibold">Your Name</label>
          <input type="text" name="FullName" placeholder="Full Name" formControlName="fullName"
            class="form-control" />
          <div *ngIf="submitted && f.fullName.errors">
            <div *ngIf="f.fullName.errors.required" class="requared">
              Full Name is required
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="semibold">Mobile</label>
          <input type="text" name="Phone number" placeholder="Phone number" formControlName="phone"
            class="form-control" />
          <div *ngIf="submitted && f.phone.errors">
            <div *ngIf="f.phone.errors.required" class="requared">
              Mobile number. is required
            </div>
            <div *ngIf="f.phone.errors.pattern" class="requared">
              Please Enter 10 digit Mobile number
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <!-- <p cla>Pick Date</p> -->
          <label class="semibold">Pick Date</label>
          <input type="date" class="form-control" min={{minDate}} name="date" placeholder="date"
            formControlName="date">
          <div *ngIf="submitted && f.date.errors">
            <div *ngIf="f.date.errors.required" class="requared">
              Date is required
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <!-- <p>Pick Time</p> -->
          <label class="semibold">Time</label>
          <input type="time" class="form-control" name="time" placeholder="time" formControlName="time">
          <div *ngIf="submitted && f.time.errors">
            <div *ngIf="f.time.errors.required" class="requared">
              Time is required
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" style="border-top: none;">
        <!-- <button type="button" class="btn btn-secondary" style="width:27%;background-color: #DCDDDD;border: 1px solid hwb(180 86% 13%);color:#2F3635;border-radius: 8px;"(click)="closePopup()">Cancel</button> -->
        <button type="submit" class="bglue reuqestacallbackpop  semibold">Submit</button>
      </div>
    </form>
  </div>
</div>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle8}">
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header color_4 color_2 Poppins-Regular">
      <h5 class="modal-title pahddingHeaderpopbox">Slot request sent</h5>
      <!-- <span aria-hidden="true">&times;</span> -->
    </div>
    <div class="contain">
      <div class="col-md-12">
        <p class="successpopub">We have received your details.
          Our health Wellness Advisors will reach you on requested date
          and time.</p>
      </div>
    </div>
    <div class="text-center" style="border-top: none;margin: 39px;">
      <button type="button" class="popubtn color_4" (click)="thankYouModelClose1(2,$event)">Okay</button>
    </div>
  </div>
</div>
</div>







<!--Payment model--->

<div class="modal" style="background: #00000087;" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle10}">
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header color_4 color_2 Poppins-Regular">
      <h5 class="modal-title pahddingHeaderpopbox"> Customer's Address</h5>
     <div style="margin-left: auto; cursor: pointer;" (click)="closemodel()">
      <span style="font-size: x-large;" aria-hidden="true">&times;</span> 
      </div>

    </div>
    <div class="contain">
      <div class="col-md-12">
        <div id="payment-form">
            <div id="address-element">
            <!-- Stripe Address Element will be inserted here. -->
          </div>
            <label for="card-element">Card information</label>
            <div id="card-element" style="padding: 15px; border: 1px solid #ced4da; border-radius: 5px;">
              <!-- A Stripe Element will be inserted here. -->
            </div>
            <div id="card-errors" role="alert"></div>

            <button (click)="handlePayment()" class="conform_payment_btn">Pay {{feeAmount | currency : "USD"}}</button>
          </div>
      </div>
    </div>
   
  </div>
</div>
</div>


 